import React, { useContext } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { Checkbox, Form, Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmOptionsContext } from '../../index'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { MILK_COWS_SLUG } from '../../constants'

const StyledTableRow = styled(Table.Row)<{$activeRow?: boolean}>`
 background: ${props => !props.$activeRow ? 'white' : 'rgb(218, 228, 238)'} !important;
`

const herdKeys = [
  'animalsNumber',
  'animalsLiveWeight',
  'soldAnimalsNumber',
  'soldAnimalsLiveWeight',
  'purchasedAnimalsNumber',
  'purchasedAnimalsLiveWeight'
]

const Herd: React.FC = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const { fields: herdGroupFields, append, remove } = useFieldArray({
    control,
    name: 'herdGroups',
    keyName: 'key'
  })

  const herdCategoryOptions = options?.herdCategories?.map(category => ({
    key: category.id,
    value: category.id,
    text: category.label,
    slug: category.slug,
    info: category.info
  })) || []

  function handleCheckedHerd(herd, checked, index) {
    if(!checked) {
      remove(index)
      return
    }

    append({
      herdCategoryId: checked ? herd.value : '',
      animalsNumber: '',
      animalsLiveWeight: '',
      soldAnimalsNumber: '',
      soldAnimalsLiveWeight: '',
      purchasedAnimalsNumber: '',
      purchasedAnimalsLiveWeight: ''
    })
  }

  function renderFormInputs(index) {
    return herdKeys.map((herdKey, indexColumn) => {
      const isKgUnit = (indexColumn + 1) % 2 === 0
      return <Table.Cell key={herdKey}>
        <FormFields.Input
          control={control}
          style={{ width: '100%' }}
          name={`herdGroups[${index}].${herdKey}`}
          placeholder={isKgUnit ? 'in kg' : '0'}
          rules={{ required: true }}
          suffix={isKgUnit ? ' kg' : ''}
          typeInput='controled'
          allowDecimals={false}
          withoutAsterisk
          noErrorMessage
      />
      </Table.Cell>
    })
  }

  function renderDisabledInputs() {
    return herdKeys.map((herdKey, indexColumn) => {
      const isKgUnit = (indexColumn + 1) % 2 === 0
      return <Table.Cell key={herdKey}>
        <Form.Input
          key={herdKey}
          placeholder={isKgUnit ? 'in kg' : '0'}
          style={{ width: '100%' }}
          disabled={true}
          value={''}
      />
      </Table.Cell>
    })
  }

  return (
    <div>
      <Table celled structured style={{ tableLayout: 'fixed' }} compact >
        <colgroup>
          <col style={{ width: '5%' }} />
          <col style={{ width: '15%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
        </colgroup>
        <Table.Header fullWidth={false}>
          <Table.Row>
            <Table.HeaderCell rowSpan='0' collapsing/>
            <Table.HeaderCell rowSpan='2'>{t('Category')}</Table.HeaderCell>
            <Table.HeaderCell colSpan='2' textAlign='center'>{t('On-farm animals')}</Table.HeaderCell>
            <Table.HeaderCell colSpan='2' textAlign='center'>{t('Sold animals')}</Table.HeaderCell>
            <Table.HeaderCell colSpan='2' textAlign='center'>{t('Purchased animals')}</Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>{t('Number')}</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>{t('Live weight')}</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>{t('Number')}</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>{t('Live weight')}</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>{t('Number')}</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>{t('Live weight')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {herdCategoryOptions.map((field) => {
            const indexHerd = herdGroupFields.findIndex(herd => herd['herdCategoryId'] === field.value)
            const selected = indexHerd >= 0
            const isMilkCowCategory = field.slug === MILK_COWS_SLUG
            return (
              <StyledTableRow key={field.key} $activeRow={!selected}>
                <Table.Cell style={{ textAlign: 'center', background: 'white' }}>
                  {!isMilkCowCategory && <Checkbox checked={Boolean(selected)} slider onChange={(_, data) => handleCheckedHerd(field, data.checked, indexHerd)}/>}
                </Table.Cell>
                <Table.Cell>
                  <div style={{ fontWeight: 'bold' }}>{field.text}</div>
                  <small style={{ fontStyle: 'italic' }}>{field.info}</small>
                </Table.Cell>
                {selected ? renderFormInputs(indexHerd) : renderDisabledInputs()}
              </StyledTableRow>
            )
          })}
        </Table.Body>
      </Table>
    </div>
  )
}

export default Herd
